// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"89":"Citas","107":"Envios","250":"Documentos","430":"Inicio","585":"Pacientes","668":"Avisos"}[chunkId] || chunkId) + "." + {"89":"86b4a4c7","107":"2eb951bd","250":"60a7aa74","298":"0340cd1c","430":"7a80982d","505":"a4c7315f","520":"b86196a7","585":"c4922f4c","668":"c105eb52"}[chunkId] + ".js";
};